export default __webpack_public_path__ + "static/media/RobotoSlab-SemiBold.edc7d6de.ttf";